import { defineComponent as q, inject as Q, ref as W, computed as v, openBlock as x, createBlock as X, Transition as Z, withCtx as ee, createElementBlock as te, normalizeClass as u, unref as n, createElementVNode as d, createVNode as ne, toDisplayString as A, createCommentVNode as oe, nextTick as se } from "vue";
import g from "./index592.js";
import { PICKER_BASE_INJECTION_KEY as ae } from "./index579.js";
import { panelTimePickerProps as ie } from "./index593.js";
import { useTimePanel as le } from "./index594.js";
import { useOldValue as re, buildAvailableTimeSlotGetter as ce } from "./index595.js";
import ue from "./index596.js";
import { useNamespace as pe } from "./index559.js";
import { useLocale as de } from "./index597.js";
import { isUndefined as me } from "./index565.js";
import { getEventCode as fe } from "./index589.js";
import { EVENT_CODE as be } from "./index590.js";
var Te = /* @__PURE__ */ q({
  __name: "panel-time-pick",
  props: ie,
  emits: ["pick", "select-range", "set-picker-option"],
  setup(E, { emit: R }) {
    const o = E, s = R, T = Q(ae), {
      arrowControl: I,
      disabledHours: h,
      disabledMinutes: k,
      disabledSeconds: V,
      defaultValue: _
    } = T.props, { getAvailableHours: D, getAvailableMinutes: N, getAvailableSeconds: y } = ce(h, k, V), r = pe("time"), { t: C, lang: m } = de(), S = W([0, 2]), w = re(o), P = v(() => me(o.actualVisible) ? `${r.namespace.value}-zoom-in-top` : ""), f = v(() => o.format.includes("ss")), B = v(() => o.format.includes("A") ? "A" : o.format.includes("a") ? "a" : ""), H = (e) => {
      const t = g(e).locale(m.value), a = b(t);
      return t.isSame(a);
    }, K = () => {
      const e = w.value;
      s("pick", e, !1), se(() => {
        w.value = e;
      });
    }, M = (e = !1, t = !1) => {
      t || s("pick", o.parsedValue, e);
    }, U = (e) => {
      if (!o.visible)
        return;
      const t = b(e).millisecond(0);
      s("pick", t, !0);
    }, $ = (e, t) => {
      s("select-range", e, t), S.value = [e, t];
    }, j = (e) => {
      const t = o.format, a = t.indexOf("HH"), p = t.indexOf("mm"), c = t.indexOf("ss"), i = [], l = [];
      a !== -1 && (i.push(a), l.push("hours")), p !== -1 && (i.push(p), l.push("minutes")), c !== -1 && f.value && (i.push(c), l.push("seconds"));
      const Y = (i.indexOf(S.value[0]) + e + i.length) % i.length;
      O.start_emitSelectRange(l[Y]);
    }, z = (e) => {
      const t = fe(e), { left: a, right: p, up: c, down: i } = be;
      if ([a, p].includes(t)) {
        j(t === a ? -1 : 1), e.preventDefault();
        return;
      }
      if ([c, i].includes(t)) {
        const l = t === c ? -1 : 1;
        O.start_scrollDown(l), e.preventDefault();
        return;
      }
    }, { timePickerOptions: O, onSetOption: F, getAvailableTime: G } = le({
      getAvailableHours: D,
      getAvailableMinutes: N,
      getAvailableSeconds: y
    }), b = (e) => G(e, o.datetimeRole || "", !0), J = (e) => e ? g(e, o.format).locale(m.value) : null, L = () => g(_).locale(m.value);
    return s("set-picker-option", ["isValidValue", H]), s("set-picker-option", ["parseUserInput", J]), s("set-picker-option", ["handleKeydownInput", z]), s("set-picker-option", ["getRangeAvailableTime", b]), s("set-picker-option", ["getDefaultValue", L]), (e, t) => (x(), X(Z, { name: P.value }, {
      default: ee(() => [
        e.actualVisible || e.visible ? (x(), te(
          "div",
          {
            key: 0,
            class: u(n(r).b("panel"))
          },
          [
            d(
              "div",
              {
                class: u([n(r).be("panel", "content"), { "has-seconds": f.value }])
              },
              [
                ne(ue, {
                  ref: "spinner",
                  role: e.datetimeRole || "start",
                  "arrow-control": n(I),
                  "show-seconds": f.value,
                  "am-pm-mode": B.value,
                  "spinner-date": (
                    // https://github.com/vuejs/language-tools/issues/2104#issuecomment-3092541527
                    e.parsedValue
                  ),
                  "disabled-hours": n(h),
                  "disabled-minutes": n(k),
                  "disabled-seconds": n(V),
                  onChange: U,
                  onSetOption: n(F),
                  onSelectRange: $
                }, null, 8, ["role", "arrow-control", "show-seconds", "am-pm-mode", "spinner-date", "disabled-hours", "disabled-minutes", "disabled-seconds", "onSetOption"])
              ],
              2
              /* CLASS */
            ),
            d(
              "div",
              {
                class: u(n(r).be("panel", "footer"))
              },
              [
                d(
                  "button",
                  {
                    type: "button",
                    class: u([n(r).be("panel", "btn"), "cancel"]),
                    onClick: K
                  },
                  A(n(C)("el.datepicker.cancel")),
                  3
                  /* TEXT, CLASS */
                ),
                d(
                  "button",
                  {
                    type: "button",
                    class: u([n(r).be("panel", "btn"), "confirm"]),
                    onClick: t[0] || (t[0] = (a) => M())
                  },
                  A(n(C)("el.datepicker.confirm")),
                  3
                  /* TEXT, CLASS */
                )
              ],
              2
              /* CLASS */
            )
          ],
          2
          /* CLASS */
        )) : oe("v-if", !0)
      ]),
      _: 1
      /* STABLE */
    }, 8, ["name"]));
  }
});
export {
  Te as default
};
